import React from 'react'
import Fade from 'react-reveal/Fade';
import Flip from 'react-reveal/Flip';
import Headline from './Headline'
import Skillbars from './Skillbars'
import Image from './Image'
//import '../stylesheets/index.scss'

import styles from '../stylesheets/About.module.scss'
import responsive from '../images/responsive.png'
import fullstack from '../images/fullstack.png'
import dynamic from '../images/dynamic.png'
import LazyLoad from 'react-lazyload';

function About() {
    return (
            <>
                <div className="container">
                    <Fade duration={2000}>
                        <Headline title="PROFILE"/>
                    </Fade>

                    <div className="row thirds">
                        <div className={"column-32"}>
                            <Flip delay={200} right>
                                <img src={fullstack} className={styles.badge} alt="fullstack"/>
                            </Flip>
                            <Fade delay={300} bottom>
                                <h2>Full Stack</h2>
                                <p>Aspiring full-stack developer drawn to the overlap between design and development. </p>
                            </Fade>
                        </div>
                        <div className={"column-32"}>
                            <Flip delay={300} right>
                                <img src={responsive} className={styles.badge} alt="responsive"/>
                            </Flip>
                            <Fade delay={400} bottom>
                                <h2>Responsive</h2>
                                <p>My designs will give the user a seamless responsive experience across all devices and screen sizes.</p>
                            </Fade>
                        </div>
                        <div className={"column-32"}>
                            <Flip delay={400} right>
                                <img src={dynamic} className={styles.badge} alt="dynamic"/>
                            </Flip>
                            <Fade delay={500} bottom>
                                <h2>Dynamic</h2>
                                <p>I have a strong passion for intuitively designed applications with dynamic content.</p>
                            </Fade>
                        </div>
                    </div>

                </div>
                <div className={styles.myself}>
                    <div className="container">
                        <div className="row halfhalf">
                            <Fade delay={600} left>
                                <div className="column-50 imagebox">
                                    <Image />
                                    <h2>Myself</h2>
                                    <p className="textbox">Le Wagon Oslo #269 graduate. Currently looking for projects and new opportunities. Proficient in both back-end and front-end frameworks.</p>
                                </div>
                            </Fade>
                            <Fade delay={600} right>
                                <div className="column-50">
                                    <LazyLoad>
                                        <Skillbars />
                                    </LazyLoad>
                                </div>
                            </Fade>
                        </div>
                    </div>
                </div>
            </>

    )
}

export default About
